export const USERNAME = "jmm_admin";
export const PASSWORD = "323!1cxsss";

export const STRIPE_CONNECT_COUNTRIES = [
  { iso: "US", name: "United States" },
  // { iso: "GB", name: "United Kingdom" },
  // { iso: "CA", name: "Canada" },
  // { iso: "IN", name: "India" },
//   { iso: "AU", name: "Australia" },
];

export const STRIPE_ONBOARDING_STATUSES = {
  INITIATED: "initiated",
  SUCCESS: "success",
  FAILED: "failed",
};

// Background check statuses used on cleaner profile and background check records
export const BACKGROUND_CHECK_STATUSES = {
  NOT_STARTED: "NOT_STARTED",
  INVITED: "INVITED",
  IN_PROGRESS: "IN_PROGRESS",
  CLEAR: "CLEAR",
  CONSIDER: "CONSIDER",
  SUSPENDED: "SUSPENDED",
  FAILED: "FAILED",
  EXPIRED: "EXPIRED",
};
